module.exports = __webpack_public_path__ + "img/tab_my_low.56facee3.png";